'use client'
import React, { ReactNode } from 'react'
import { Box } from '@mui/material'
import useScrollToTop from '../../hook/useScrollToTop'
import { Toast } from '../kit/components/toast'


type GlobalLayoutProps = { children: ReactNode }

export default function GlobalLayout({
  children,
}: GlobalLayoutProps): JSX.Element {
  useScrollToTop()
  return (
    <Box sx={{minHeight:'100dvh',height:'100%'}}>
      {children}
      <Toast/>
    </Box>
  )
}
